"use client" 

import ModalOverlay from "../../Atoms/ModalOverlay.js";
import ModalHeader from "./ModalHeader.js";
import ModalFooter from "./ModalFooter.js";
import { GrayButton, IndigoButton, TealButton } from "@/components/Atoms/Buttons/ColorButtons.js";
import { useState, useEffect } from "react";
import { useRouter } from "next/navigation.js";
import { getEntityLocationStr, standardizeFileName } from "@/utils/frontend/stringOps.js";
import { getCookies } from "@/utils/frontend/cookieOps.js";
import Alert from "@/components/Atoms/Alerts/Alert.js";
import CheckCardEntity from "@/components/Atoms/CheckCards.js/CheckCardEntity.js";
import TalentPreviewCard from "../Cards/TalentPreviewCard.js";
import ModalSwitchFooter from "./ModalSwitchFooter.js";
import JobPreviewCard from "../Cards/JobPreviewCard.js";
import EventTimeline from "../EventTimeline.js";
import NewMessageCard from "../Cards/Social/NewMessageCard.js";
import FileUploadDragAndDrop from "@/components/Atoms/FileUploadDragAndDrop.js";
const SubmissionModalWorkspace = ({user, state, lang, userType, callback, talentData, jobData, submissionData}) => {
  console.log("SUBMISSIONDATA", submissionData)
// console.log('jdata', jobData)
  // const user = getCookies().user
  // console.log('subData', submissionData)

       const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://talnet.co';
    const router = useRouter()


  let checkedIds = []
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const [talentPreviewOpen, setTalentPreviewOpen] = useState(true)
  const [talentTarget, setTalentTarget] = useState(null)
  const [jobPreviewOpen, setJobPreviewOpen] = useState(true)
  const [jobTarget, setJobTarget] = useState()
  const [submissionTarget, setSubmissionTarget] = useState()
    // file
  const [fileUploadDialogOpen, setFileUploadDialogOpen] = useState(false)
  const [fileData, setFileData] = useState(null)
  const [filePreview, setFilePreview] = useState(null)
  const [resumeIsReleased, setResumeIsReleased] = useState(false)

  useEffect(() => {
    
    if (jobData) {
      setJobTarget({...jobData})
    }
    else { setJobTarget(null) }

    if (talentData) {
      setTalentTarget({...talentData})
    }
    else { setTalentTarget(null) }

    const init = async () => {
      if (!submissionData){ return;}
      // console.log("AWAITING")
      await releaseCheck(submissionData.relation_uuid)
    }
    init()

    if (submissionData) {setSubmissionTarget({...submissionData})}

    // if (parentComponent === 'WORKSPACE') {
    //   // register a submission view here if parent component is WORKSPACE (getData put /api/submissions)
    // }
  }, [jobData, talentData, submissionData])
  // const handleCheckCardCallback = (cb) => {
  //   console.log(cb)
  //   if (cb.checkedId) { 
  //     checkedIds.push(cb.checkedId)
  //   }
  //   else { // cb.unchecked
  //     let index = checkedIds.indexOf(cb.uncheckedId);
  //     if (index > -1) { // only splice array when item is found
  //       checkedIds.splice(index, 1); // 2nd parameter means remove one item only
  //     }
  //   }
  // }

  const handleNewMessageCardCallback = async cb => {
    console.log('cb@newmessage', cb)





    const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://talnet.co';
    /*---------------------------------------
      PUT new message in submission events
    ---------------------------------------*/
        
    try {
        const response = await fetch(`${baseUrl}/api/submissions/${submissionData.relation_uuid}?user_type=${user.user_type}&event_type=${'MESSAGED'}`, {
            method: 'PUT',
            headers: {
                'Accept': '*/*',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({data: {message: cb.newMessage}}) // Necessary for cookies if API is on the same domain
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        console.log("DATA@HANDLESUBMISSIONPUT", data)
        // setRecordsTable(data.data?.reverse());
        // setSubmissionsToRender(data.data);
        
        // console.log("DATA@admin/page.js", data); // Log to see what the data looks like
    } catch (error) {
        console.error('Failed to fetch jobs:', error);
    }
    finally {

      // callback({refreshData: true})
      // router.refresh()
        // setDataGridDataLoading(false)
    }



    /*---------------------------------------
      GET updated submission event
    ---------------------------------------*/
    try {
        const response = await fetch(`${baseUrl}/api/submissions/${submissionData.relation_uuid}?user_type=${user.user_type}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Content-Type': 'application/json'
            },
            credentials: 'include', // Necessary for cookies if API is on the same domain
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        console.log("DATA@GETSUBMISSION", data)
        // setRecordsTable(data.data?.reverse());
        setSubmissionTarget(data.data);
        console.log("SUBTARGET", submissionTarget)
        // console.log("DATA@admin/page.js", data); // Log to see what the data looks like
    } catch (error) {
        console.error('Failed to fetch jobs:', error);
    }
    finally {
        // setDataGridDataLoading(false)
    }

       






  }


  


  const releaseCheck = async (relationUUID) => {
        const response = await fetch(
      `/api/submissions/${relationUUID}/resume?user_type=${user.user_type}&download_file=false`,
      {
        method: "GET",
        credentials: "include"
      }
    );
    let res = await response.json()
    console.log("res@releaseCheck", res)
    console.log('response@releaseCheck', response)

    // if the resume is in files, and the CV_RELEASED event is present
    if (res.resumeFound === true) { 
      console.log('SUBMISSION EVENTS', submissionData.events.events)
      setResumeIsReleased(true)
    }

    if (!response.ok) {
      setError({message: 'Failed to fetch file'})
      setResumeIsReleased(false)
      throw new Error("Failed to fetch file");
    }
  }



  const handleDownloadCV = async () => {
    setLoading(true)
  try {
    const response = await fetch(
      `/api/submissions/${submissionTarget.relation_uuid}/resume?user_type=${user.user_type}&download_file=true`,
      {
        method: "GET",
        credentials: "include"
      }
    );
    // let res = await response.json()
    console.log('response', response)

    if (!response.ok) {
      setError({message: 'Failed to fetch file'})
      throw new Error("Failed to fetch file");
    }

    const blob = await response.blob();

    // Create temporary download link
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;

    // Optional: set filename
    a.download = "cv.pdf";

    document.body.appendChild(a);
    a.click();

    // Cleanup
    a.remove();
    window.URL.revokeObjectURL(url);
    setLoading(false)
  } catch (err) {
    console.error("Download failed:", err);
    setLoading(false)
  }
};







    const handleFileUpload = (cb) => {

    if (cb.action === 'fileUpload') {
      setFileData({...fileData, file_name: standardizeFileName(cb.file.name), file_extension: cb.file.name.split('.')[1], file: cb.file})
      setFilePreview(URL.createObjectURL(cb.file))
    }

        if (cb === 'closeDialog' || cb === 'isDropped') {
      setFileUploadDialogOpen(false)
    }

    // if (cb === 'closeDialog' || cb === 'isDropped') {
    //   setFileUploadDialogOpen(false)
    // }
  }



  const handleSubmitFile = async () => {
    if (fileData?.file) {
      const formData = new FormData();
      formData.append("file", fileData.file, fileData.file_name);
      formData.append("file_name", fileData.file_name);
      formData.append("file_extension", fileData.file_extension);
      formData.append("user", JSON.stringify(user));
      // formData.append("record_data", JSON.stringify(recordPayload))

      let mediaUploadResponse = await fetch(
        `/api/services/files?user_type=${user.user_type}&file_type=DOCUMENT&parent_record_uuid=${talentTarget ? talentTarget.talent_uuid : recordUUID}&record_type=TALENT`,
        {
          method: "POST",
          credentials: "include",
          body: formData,
        }
      );

      console.log(mediaUploadResponse.status)

      /*---------------------------------------------------
      write the event to jobsTalentsRelationTable
      --------------------------------------------------*/
      try {
        const response = await fetch(`${baseUrl}/api/submissions/${submissionData.relation_uuid}?user_type=${user.user_type}&event_type=${'CV_RELEASED'}`, {
            method: 'PUT',
            headers: {
                'Accept': '*/*',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            // body: JSON.stringify({data: {message: cb.newMessage}}) // Necessary for cookies if API is on the same domain
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        console.log("DATA@HANDLESUBMISSIONPUT", data)
        } catch (error) {
            console.error('Failed to fetch jobs:', error);
        }

      if (mediaUploadResponse.status !== 200) {

        mediaUploadResponse.status === 401 && deleteTalnetBrowserCookies()


        mediaUploadResponse = await mediaUploadResponse.json()
        console.log('ERROR: ', mediaUploadResponse.error)
        setError({message: `Couldn't upload file. Error: ${mediaUploadResponse.error.message || mediaUploadResponse.error  }`})
        setLoading(false);
        return;
      }
    }
  }




 
  
  const handleSubmit = async () => {
  
  setLoading(true)
  if (checkedIds.length < 1) {
    setError({message: lang === 'fr' ? 'Pas de candidats selectionnés' : 'No candidates selected'})
    setLoading(false)
    return;
  }

    try {
        
      let jobApiUrl = `/api/submissions?user_type=${user.user_type}`
      let response = await fetch(jobApiUrl, {
      method: `${'POST'}`, // Use uppercase for HTTP methods
      headers: {
        'Accept': '*/*',
        'Content-Type': 'application/json'
      },
      credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
      body: JSON.stringify({data: {talent_ids: checkedIds, job_data: JSON.stringify(jobData)}, user: user, lang:lang}), // Convert the credentials object to a JSON string
      // body: data
    });

    response = await response.json()

  if (response.success === true ) {
    setSuccess({message: lang === 'fr' ? "Le(s) candidat(s) ont été soumis." : 'The candidate(s) have been submitted.'})
    setTimeout(() => {
      router.push('?')
    }, 2000);
    // state.setJobModalOpen(false)
  }
  else { 
    setError({message: lang === 'fr' ? "Il y a eu un problème lors de la soumissions." : 'There was a problem during submission.'})
  }
  callback({refreshData: true})

        
    } catch (error) {
      console.log('error', error)
    } finally {setLoading(false)}

  
    // try {
    //   let apiUrl = `/api/candidatures/recruiter`;
    //   let response = await fetch(apiUrl, {
    //     method: 'POST',
    //     credentials: 'include', // Keep this if you need cookies sent
    //     body: JSON.stringify(checkedIds), // Send formData object,
    //   });
  
    //   let responseJSON = await response.json();
  
    //   console.log("Response: ", responseJSON)
    //   if (response.status===200){
    //     let successMessage; 
    //     if (registering){
    //       successMessage = lang === 'fr' ?  "Votre compte a été créé et candidature soumise." : "Your account has been created and candidature submitted."
    //     }
    //     else {
    //       successMessage = lang === 'fr' ? "Votre candidature a été soumise." : "Your candidature has been submitted."
    //     }
    //     setSuccess({ message: successMessage });
    //     // document.cookie = `token=${JSON.stringify(await responseJSON.token)}`;
    //     console.log(`resJSON`, responseJSON)
    //     if (registering){
    //       document.cookie = `user=${JSON.stringify(await responseJSON.user)}; path=/;`;
    //     }
    //     // document.cookie = `organization=${JSON.stringify(await responseJSON.organization)}; path=/;`;
    //         // window.location.href = `../workspace/`
    //     }
    //   else {
    //     // duplicate entry of unique value
    //     if (responseJSON.error.original?.errno === 1062) { 
    //       let errKeys = Object.keys(responseJSON.error.fields)
    //       let errValues = Object.values(responseJSON.error.fields)
    //       setError({message: lang === 'fr' ? `${humanizeString(errKeys.toString())} existe déjà.` : `${humanizeString(errKeys.toString())} already exists.`})
    //       setMissingFields({...missingFields,  [errKeys]: true})
    //     }
    //     else {
    //       setError({message: lang === 'fr' ? `Erreur: ${response.status} - ${responseJSON.error}` : `Error: ${response.status} - ${responseJSON.error}`})
    //     }
    //   }
  
  
  
  
  
    //   // setSuccess({message: lang === 'fr' ? "Votre candidature a été soumise." : "Your candidature has been submitted."})
  
    // } catch (error) {
    //   console.log('error', error);
    //   setError({message: lang === 'fr' ? `Votre candidature n'a pas été soumise\n${error}` : `Your candidature has not been submitted.\n${error}`})
    // } 
  
  };
















  
     function getFormattedDate() {
          const options = { year: 'numeric', month: 'short', day: 'numeric' };
          const today = new Date();
          return today.toLocaleDateString('en-GB', options); // 'en-GB' ensures the format is Day Month, Year
        }

        const [modalOpen, setModalOpen] = useState(false)
        
        const handleKeyDown = (e) => {
          if (e.key === 'Escape') {
            router.push('?')
          }
        };

     return (
<div onKeyDown={handleKeyDown} tabIndex={0}>



                 <Alert state={{success: success, setSuccess: setSuccess, error: error, setError: setError}} message={success ? success.message : error ? error.message : ''}/>
  <div
  className={`
    fixed inset-0 z-40
    grid grid-cols-12
    transition-transform duration-300 ease-in-out
    ${state.submissionModalOpen ? 'translate-x-0' : 'translate-x-full'}
  `}
>
    {/* 3 rows were - absolute, fixed, fixed instead of 3x relative*/}
    {/*--------------------------------------
     TIMELINE SECTION - 7/12 - left 
     --------------------------------------*/}
<div
  className={`
    overflow-y-scroll transition-all duration-300
    col-span-12 h-screen
    ${
      talentPreviewOpen && jobPreviewOpen ?
      'lg:col-span-4' :
      talentPreviewOpen || jobPreviewOpen
        ? 'lg:col-span-6' 
        : 'lg:col-span-12'
    }
  `}
>

<div className="relative flex flex-col w-full bg-white dark:bg-gray-900 outline-none h-screen">
  {/* Header */}
  <div className="flex items-center">
    <ModalHeader
      caption={lang === 'fr' ? 'Sélection de candidats' : <><i className="fa-solid fa-timeline"></i> Timeline</>}
      closeOnClickMethod={() => state.setSubmissionModalOpen(false)}
    />
  </div>

  {/* Scrollable content */}
  <div className="flex-1 overflow-y-auto px-6 py-4">
    <EventTimeline 
    // events={submissionTarget?.events.events || submissionData?.events.events || []} 
      // events={submissionTarget?.events?.events ?? []}
        events={submissionTarget?.events?.events || []}

  //     events = { submissionTarget?.events?.events ??
  // submissionData?.events?.events ??
  // []}
    />
  </div>



<div className="my-2 px-6 flex w-full items-center gap-2">
  <div>
    <p className="text-sm">{fileData?.file_name && fileData?.file_name?.substring(0, 20)+'...'+fileData?.file_extension}
      </p>
    </div>
  <div className={`flex items-center ${fileUploadDialogOpen === true ? 'justify-center' : 'justify-end'} w-full`}>
      {fileUploadDialogOpen === true ? 
      <FileUploadDragAndDrop 
    acceptedFileTypes={'documents'} 
    // isCloseable={false} 
    paddingY={'sm'} lang={'en'} fileName={fileData?.file_name || ''} 
    // callback={(cb)=>{cb === 'closeDialog' && setFileUploadDialogOpen(false)}}
    callback={handleFileUpload}
    />
    :
    <div className="flex items-center justify-center flex-row gap-2">
      <div className="max-w-96">

{/* only show download cv button to the job owner and if resume is released */}
{(resumeIsReleased === true && user.user_uuid === submissionData?.job_user_uuid) && <TealButton
        loading={loading}
  caption="Download CV"
  onClick={handleDownloadCV}
/>}

</div>
{/* only show upload & release full profile button to the candidate owner */}
{(resumeIsReleased === false && user.user_uuid !== submissionData?.job_user_uuid) ? 
<div className="max-w-96">
    <TealButton buttonSize={0} 
    disabled={resumeIsReleased === true}
    caption={fileData?.file_name ? 
    'Confirm & Release'
      // fileData?.file_name?.substring(0, 20)+'...'+fileData?.file_extension
       : 'Upload & Release Full Profile'} onClick={()=>{ 
        fileData?.file_name ? handleSubmitFile() : setFileUploadDialogOpen(true)
        }}/>
      </div> :
      <div>
        <p className="text-sm">
        {resumeIsReleased === true && 'Full resume has been released'}
        </p>
        </div>
        }
      </div>
    }
    </div>

  </div>
  {/* Sticky message card */}
  <div className="sticky bottom-0 z-10 bg-white dark:bg-gray-900 px-6 py-2 border-t border-slate-100 dark:border-gray-700 flex">
    {/* <div>
          <ModalSwitchFooter 
      modal1switch={()=>setTalentPreviewOpen(!talentPreviewOpen)}
      modal1caption={'Talent'}
      modal1isOpen={talentPreviewOpen}
      modal2switch={()=>setJobPreviewOpen(!jobPreviewOpen)}
      modal2caption={'Job'}
      modal2isOpen={jobPreviewOpen}
submitButtonCaption2={lang === 'fr' ? !talentPreviewOpen ? <><i className="fa-solid fa-eye mr-1"/>Ouvrir Aperçu</> : <><i className="fa-solid fa-eye-slash mr-1"/>Fermer Aperçu</> : talentPreviewOpen ? <><i className="fa-solid fa-eye-slash mr-1"/>Close Preview</> : <><i className="fa-solid fa-eye mr-1"/>Open Preview</>}
/></div> */}


<div className="flex justify-center w-full items-center">
    <div className="max-w-3xl w-full">
      <NewMessageCard placeholder={'Write a message..'} user={user} parentComponent="SUBMISSIONS" callback={handleNewMessageCardCallback} />
    </div>
    </div>
  </div>
</div>
      {/* <div ref={chatBottomRef} /> */}
    </div>


 


{/* ----------------
  TALENT PREVIEW MODAL
------------------*/}
<div
  className={`
    transition-all duration-300 ease-in-out
    hidden lg:block
    ${
      talentPreviewOpen && jobPreviewOpen
        ? 'lg:col-span-4'
        : talentPreviewOpen
        ? 'lg:col-span-6'
        : 'lg:hidden'
    }
    ${
      talentPreviewOpen
        ? 'opacity-100 translate-x-0'
        : 'opacity-0 translate-x-full pointer-events-none'
    }
  `}
>


                <div className="border-0 min-h-screen shadow-none relative flex flex-col w-full outline-none focus:outline-none bg-slate-50 dark:bg-slate-800">

                  <ModalHeader caption={lang === 'fr' ? <><i className="fa-solid fa-binoculars mr-2"/>Aperçu Talent</> : <><i className="fa-solid fa-binoculars mr-2"/>Talent Preview</>} closeOnClickMethod={() => {setTalentPreviewOpen(false)}}/>

                  <br/>
                  <div className="px-8">
                  
  {talentTarget && 
                  <TalentPreviewCard
                            lang={lang || 'en'}
                            data={talentTarget}
                            tags={talentTarget.tags}

                          />
                          }
                  </div>
                    
                      </div>
                      
    </div>


    {/*-------------------------------- 
    JOB PREVIEW MODAL - 5/12 - right 
    ----------------------------------*/}
<div
  className={`
    overflow-y-scroll transition-all duration-300 ease-in-out
    hidden lg:block overflow-y-scroll
    ${
      jobPreviewOpen && talentPreviewOpen
        ? 'lg:col-span-4'
        : jobPreviewOpen
        ? 'lg:col-span-6'
        : ''
    }
    ${
      jobPreviewOpen
        ? 'opacity-100 translate-x-0'
        : 'opacity-0 translate-x-full pointer-events-none'
    }
  `}
>
                {/*content*/}
                <div className="border-0 min-h-screen shadow-none relative flex flex-col w-full outline-none focus:outline-none bg-slate-50 dark:bg-slate-800">
                  {/*header*/}
                  {/* <div className="flex items-start z-40 justify-between p-5 border-b border-solid border-slate-200 rounded-t"> */}
                  
                  <ModalHeader caption={lang === 'fr' ? <><i className="fa-solid fa-binoculars mr-2"/>Aperçu Poste</> : <><i className="fa-solid fa-binoculars mr-2"/>Job Preview</>} closeOnClickMethod={() => setJobPreviewOpen(false)}/>
                  {/* <div className="fixed top-0 bg-inherit flex items-center z-50 px-2 py-1 h-screen">
                    test
                  </div> */}
                  <br/>
                  <div className="px-8">
                 {/* {console.log('jTarg', jobTarget)} */}
  {jobTarget && 
                  <JobPreviewCard
                            lang={lang || 'en'}
                            data={{...jobTarget, job_title_en: jobTarget.job_title['en'], job_title_fr: jobTarget.job_title['fr']}}
                            tags={jobData.tags}

                          />
                          }
                  </div>
                  {/* col-span-1 border rounded-lg p-4 prose prose-sm max-w-none h-96 overflow-y-auto bg-white text-slate-700 whitespace-pre-wrap */}

                  {/* {data[`job_description_${lang || 'en'}`] && <div className={`mx-8 px-6 py-8 my-10 rounded-xl bg-white dark:bg-gray-900 shadow-lg flex-col h-full text-slate-500 dark:text-slate-300 font-inter overflow-auto whitespace-pre-wrap max-w-none `}>

                  <ReactMarkdownMod args={data[fieldInFocus || `job_description_${lang || 'en'}`]}/>
              
                    </div>} */}
   
   
                  {/* <div className="relative p-6 flex-auto text-left">
                    <div className="my-4 text-slate-500 text-lg leading-relaxed text-gray-900 dark:text-slate-200">
                    </div>
                  </div> */}
                      
                    
                      </div>
                      
    </div>

    <ModalSwitchFooter 
      modal1switch={()=>setTalentPreviewOpen(!talentPreviewOpen)}
      modal1caption={'Talent'}
      modal1isOpen={talentPreviewOpen}
      modal2switch={()=>setJobPreviewOpen(!jobPreviewOpen)}
      modal2caption={'Job'}
      modal2isOpen={jobPreviewOpen}

submitButtonCaption2={lang === 'fr' ? !talentPreviewOpen ? <><i className="fa-solid fa-eye mr-1"/>Ouvrir Aperçu</> : <><i className="fa-solid fa-eye-slash mr-1"/>Fermer Aperçu</> : talentPreviewOpen ? <><i className="fa-solid fa-eye-slash mr-1"/>Close Preview</> : <><i className="fa-solid fa-eye mr-1"/>Open Preview</>}
/>

  </div>
  {state.submissionModalOpen && < ModalOverlay />}
</div>
     )
}

export default SubmissionModalWorkspace







































// "use client" 

// import ModalOverlay from "../../Atoms/ModalOverlay.js";
// import ModalHeader from "./ModalHeader.js";
// import ModalFooter from "./ModalFooter.js";
// import { GrayButton, IndigoButton, TealButton } from "@/components/Atoms/Buttons/ColorButtons.js";
// import { useState } from "react";
// import { useRouter } from "next/navigation.js";
// import { getEntityLocationStr } from "@/utils/frontend/stringOps.js";
// import { getCookies } from "@/utils/frontend/cookieOps.js";
// import Alert from "@/components/Atoms/Alerts/Alert.js";
// import CheckCardEntity from "@/components/Atoms/CheckCards.js/CheckCardEntity.js";
// import TalentPreviewCard from "../Cards/TalentPreviewCard.js";
// import ModalSwitchFooter from "./ModalSwitchFooter.js";
// const TalentSubmissionModal = ({state, lang, userType, callback, talents, jobData}) => {

//   const user = getCookies().user

//   let checkedIds = []

//   const handleCheckCardCallback = (cb) => {
//     console.log(cb)
//     if (cb.checkedId) { 
//       checkedIds.push(cb.checkedId)
//     }
//     else { // cb.unchecked
//       let index = checkedIds.indexOf(cb.uncheckedId);
//       if (index > -1) { // only splice array when item is found
//         checkedIds.splice(index, 1); // 2nd parameter means remove one item only
//       }
//     }
//   }

//   const [loading, setLoading] = useState(false)
//   const [error, setError] = useState(null)
//   const [success, setSuccess] = useState(null)
//   const [talentPreviewOpen, setTalentPreviewOpen] = useState(false)
//   const [jobPreviewOpen, setJobPreviewOpen] = useState(false)
//   const [talentTarget, setTalentTarget] = useState(null)
//   const [jobTarget, setJobTarget] = useState(null)


  








//   // const postPutData = {
//   //   first_name: data?.first_name || candidateFromCookies?.user_first_name,
//   //   last_name: data?.last_name || candidateFromCookies?.user_last_name,
//   //   phone_number: data?.phone_number || candidateFromCookies?.user_phone_number,
//   //   email_address: data?.email_address || candidateFromCookies?.user_email_address,
//   //   salary: data?.salary,
//   //   access_level: data?.talent_access_level,
//   //   message: data?.message,
//   //   location: data?.location,
//   //   tags: data?.tags,
//   //   lang: lang,
//   //   file: data?.file || null,
//   //   file_name: data?.file_name,
//   //   file_extension: data?.file_extension,
//   //   user_eula: data?.user_accepted_eula,
//   //   user_password: data?.user_password,
//   //   user_password_repeat: data?.user_password_repeat
//   // }
  
  
  
  
//   const handleSubmit = async () => {
  
//   setLoading(true)
//   if (checkedIds.length < 1) {
//     setError({message: lang === 'fr' ? 'Pas de candidats selectionnés' : 'No candidates selected'})
//     setLoading(false)
//     return;
//   }

//     try {
        
//       let jobApiUrl = `/api/submissions?user_type=${user.user_type}`
//       let response = await fetch(jobApiUrl, {
//       method: `${'POST'}`, // Use uppercase for HTTP methods
//       headers: {
//         'Accept': '*/*',
//         'Content-Type': 'application/json'
//       },
//       credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
//       body: JSON.stringify({data: {talent_ids: checkedIds, job_data: JSON.stringify(jobData)}, user: user, lang:lang}), // Convert the credentials object to a JSON string
//       // body: data
//     });

//     response = await response.json()

//   if (response.success === true ) {
//     setSuccess({message: lang === 'fr' ? "Le(s) candidat(s) ont été soumis." : 'The candidate(s) have been submitted.'})
//     setTimeout(() => {
//       router.push('?')
//     }, 2000);
//     // state.setJobModalOpen(false)
//   }
//   else { 
//     setError({message: lang === 'fr' ? "Il y a eu un problème lors de la soumissions." : 'There was a problem during submission.'})
//   }
//   callback({refreshData: true})

        
//     } catch (error) {
//       console.log('error', error)
//     } finally {setLoading(false)}

  
//     // try {
//     //   let apiUrl = `/api/candidatures/recruiter`;
//     //   let response = await fetch(apiUrl, {
//     //     method: 'POST',
//     //     credentials: 'include', // Keep this if you need cookies sent
//     //     body: JSON.stringify(checkedIds), // Send formData object,
//     //   });
  
//     //   let responseJSON = await response.json();
  
//     //   console.log("Response: ", responseJSON)
//     //   if (response.status===200){
//     //     let successMessage; 
//     //     if (registering){
//     //       successMessage = lang === 'fr' ?  "Votre compte a été créé et candidature soumise." : "Your account has been created and candidature submitted."
//     //     }
//     //     else {
//     //       successMessage = lang === 'fr' ? "Votre candidature a été soumise." : "Your candidature has been submitted."
//     //     }
//     //     setSuccess({ message: successMessage });
//     //     // document.cookie = `token=${JSON.stringify(await responseJSON.token)}`;
//     //     console.log(`resJSON`, responseJSON)
//     //     if (registering){
//     //       document.cookie = `user=${JSON.stringify(await responseJSON.user)}; path=/;`;
//     //     }
//     //     // document.cookie = `organization=${JSON.stringify(await responseJSON.organization)}; path=/;`;
//     //         // window.location.href = `../workspace/`
//     //     }
//     //   else {
//     //     // duplicate entry of unique value
//     //     if (responseJSON.error.original?.errno === 1062) { 
//     //       let errKeys = Object.keys(responseJSON.error.fields)
//     //       let errValues = Object.values(responseJSON.error.fields)
//     //       setError({message: lang === 'fr' ? `${humanizeString(errKeys.toString())} existe déjà.` : `${humanizeString(errKeys.toString())} already exists.`})
//     //       setMissingFields({...missingFields,  [errKeys]: true})
//     //     }
//     //     else {
//     //       setError({message: lang === 'fr' ? `Erreur: ${response.status} - ${responseJSON.error}` : `Error: ${response.status} - ${responseJSON.error}`})
//     //     }
//     //   }
  
  
  
  
  
//     //   // setSuccess({message: lang === 'fr' ? "Votre candidature a été soumise." : "Your candidature has been submitted."})
  
//     // } catch (error) {
//     //   console.log('error', error);
//     //   setError({message: lang === 'fr' ? `Votre candidature n'a pas été soumise\n${error}` : `Your candidature has not been submitted.\n${error}`})
//     // } 
  
//   };















//   const router = useRouter()
  
//      function getFormattedDate() {
//           const options = { year: 'numeric', month: 'short', day: 'numeric' };
//           const today = new Date();
//           return today.toLocaleDateString('en-GB', options); // 'en-GB' ensures the format is Day Month, Year
//         }

//         const [modalOpen, setModalOpen] = useState(false)
        
//         const handleKeyDown = (e) => {
//           if (e.key === 'Escape') {
//             router.push('?')
//           }
//         };

//      return (
// <div onKeyDown={handleKeyDown} tabIndex={0}>





































//                  <Alert state={{success: success, setSuccess: setSuccess, error: error, setError: setError}} message={success ? success.message : error ? error.message : ''}/>
//   <div
//     className={`fixed inset-0 z-40 outline-none focus:outline-none transition-transform duration-300 ease-in-out transform ${
//       state.submissionModalOpen ? 'translate-x-0' : 'translate-x-full'
//     } flex`}
//   >
//     {/* 3 rows were - absolute, fixed, fixed instead of 3x relative*/}
//     {/* TALENT SELECTION MODAL - 7/12 - left */}
//     {/* <div className=" w-6/6 shadow-2xl rounded-3xl sm:w-4/6 lg:w-3/4 lg:w-2/4 xl:w-2/4 2xl:w-2/4 overflow-y-auto h-[50vh]"> */}
// <div className={`duration-300 ease-in-out transition-transform transform ${talentPreviewOpen || jobPreviewOpen ? 'relative lg:w-full' : 'absolute lg:w-full'} top-0 min-h-screen`}>
//       {/* Modal Content */}
//       <div className="relative flex flex-col w-full bg-white outline-none focus:outline-none dark:bg-gray-900 px-6 overflow-y-auto h-screen">
//   {/* Flex container for close button and title */}
//   <div className="flex items-center">

//   <ModalHeader caption={lang === 'fr' ? 'Sélection de candidats' : 'Select Talent'} closeOnClickMethod={() => {
//                     // setModalOpen(false); router.push(`passive`)
//                     setModalOpen(false); 
//                     router.push('?')
//                     }}/>

//   </div>
//   <div className="flex flex-col justify-between h-full">
//   <div className="mt-8 text-xs font-inter dark:text-gray-300">
//   <div className="space-y-6 mb-2">
//                          {talents.map(talent=> 

//                               // <div key={talent.id} className="flex items-center border border-slate-300 dark:border-slate-500 rounded-md p-2 text-sm">
//                               //      <span><input type="checkbox" className="mr-1 flex"/></span>
//                               //      <span>{talent.talent_full_name}</span>
//                               //      <div>{talent.talent_full_name}</div>
//                               //      <div>{talent.talent_job_title[lang]}</div>
//                               //      <div>{getEntityLocationStr('talent', talent)}</div>
//                               // </div>
//                               { console.log(talent.submissions)
//                                 // check if talent was already submitted for this job
//                                  const talentAlreadySubmitted = talent.submissions.some(submission=> submission.job_id === jobData.id)
//                                 //  console.log(talent.submissions.filter(submission=> {console.log('sub',submission.job_id === jobData.id)}))

//                                  return (
                                 
//                                  <div disabled={true} key = {talent.id} className={`w-full`}>
//                                 <div className={`rounded-xl dark:bg-slate-950 relative items-center justify-center min-h-24 w-full`}>
//                          {/* add flex to class above to have caption centered  */}
//   {/* <div className="absolute top-1/2 top-[-2px] transform -translate-y-1/2 text-gray-900 dark:text-gray-300">
//     {talent.submissions && talentAlreadySubmitted && <span className={`bg-white dark:bg-gray-800 rounded-md px-4 py-1 font-inter  text-slate-400 dark:text-slate-300 text-xs border border-teal-400 font-inter ml-2`}>
//     <i className="fa-regular fa-circle-check text-teal-400"></i> {lang === 'fr' ? 'Talent déjà soumis pour ce poste' : 'Talent already submitted for this job'}</span>}
//     <span className={`bg-white dark:bg-gray-800 rounded-md px-4 py-1 font-inter  text-slate-400 dark:text-slate-300 text-xs border border-teal-400 font-inter ml-2`}>
//    <i className="fa-solid fa-binoculars"></i></span>
    
//   </div> */}
//   <div className="absolute inset-x-0 top-1/2 top-[-2px] transform -translate-y-1/2 flex items-center justify-between px-2 text-gray-900 dark:text-gray-300">
  
//   {/* LEFT SIDE */}
//   <div>
//     {talent.submissions && talentAlreadySubmitted && (
//       <span className="bg-white dark:bg-gray-800 rounded-md px-4 py-1 text-xs border border-teal-400 text-slate-400 dark:text-slate-300">
//         <i className="fa-regular fa-circle-check text-teal-400 mr-1"></i>
//         {lang === 'fr'
//           ? 'Talent déjà soumis pour ce poste'
//           : 'Talent already submitted for this job'}
//       </span>
//     )}
//   </div>

//   {/* RIGHT SIDE */}
//   <div className="duration-150 text-slate-700 hover:text-slate-400 " onClick={()=>{setTalentPreviewOpen(true); setTalentTarget(talent)}}>
//     <span className="bg-white dark:bg-gray-800 cursor-pointer rounded-md px-4 py-1 text-xs border border-teal-400 dark:text-slate-300">
//       <i className="fa-solid fa-binoculars"></i>
//     </span>
//   </div>

// </div>
//      <CheckCardEntity fullEntity={talent} defaultChecked={talentAlreadySubmitted} hasExistingRelation={talentAlreadySubmitted} callback={handleCheckCardCallback} text1={talent.talent_full_name} text2={getEntityLocationStr('talent', talent)} text3={talent.talent_job_title[lang]} id={talent.id}/>
// </div>

   
//                               </div>)}
//                          )}
//                     </div>
//   </div>
//   {/* Other modal content */}
//   <div>
//     <TealButton loading={loading} onClick={()=>handleSubmit()} caption={lang === 'fr' ? `Soumettre le(s) Candidats` : `Submit Candidate(s)`}/>
//   </div>
//   </div>
//   <div className="mt-4 text-sm text-teal-400 mx-auto">
//     {/* {error && <>[ Error: {error.message} ]</>}
//     {success && <>[ Success: {success.message} ]</>} */}
//   </div>
// </div>
//     </div>


//     {/* TALENT PREVIEW MODAL - 5/12 - middle */}
//     <div className={`min-h-screen lg:w-6/12 duration-300 ease-in-out  ${talentPreviewOpen === true ? 'opacity-100 -translate-x-0 pointer-events-auto' : 'opacity-0 translate-x-full pointer-events-none w-0'}`}>

//                 <div className="border-0 min-h-screen shadow-none relative flex flex-col w-full outline-none focus:outline-none bg-slate-50 dark:bg-slate-800">

//                   <ModalHeader caption={lang === 'fr' ? <><i className="fa-solid fa-binoculars mr-2"/>Aperçu Talent</> : <><i className="fa-solid fa-binoculars mr-2"/>Talent Preview</>} closeOnClickMethod={() => setTalentPreviewOpen(false)}/>

//                   <br/>
//                   <div className="px-8">
                  
//   {talentTarget && 
//                   <TalentPreviewCard
//                             lang={lang || 'en'}
//                             data={talentTarget}
//                             tags={talentTarget.tags}

//                           />
//                           }
//                   </div>
                    
//                       </div>
                      
//     </div>
//     {/* <div
//   className={`
//     min-h-screen w-0 lg:w-4/12
//     transition-all duration-300 ease-in-out
//     ${talentPreviewOpen
//       ? 'opacity-100 translate-x-0 pointer-events-auto'
//       : 'opacity-0 translate-x-full pointer-events-none w-0'}
//   `}
// >
//   <div className="h-full bg-slate-50 dark:bg-slate-800">
//     <ModalHeader
//       caption={lang === 'fr' ? 'Aperçu Talent' : 'Talent Preview'}
//       closeOnClickMethod={() => setTalentPreviewOpen(false)}
//     />
//     {talentTarget && <TalentPreviewCard data={talentTarget} />}
//   </div>
// </div> */}


//     {/* JOB PREVIEW MODAL - 5/12 - right */}
//         <div className={`relative right-0 top-0 min-h-screen ${talentPreviewOpen ? 'w-4/12' : 'w-8/12'} duration-300 ease-in-out transition-transform transform invisible lg:visible ${jobPreviewOpen === true ? 'translate-x-0' : 'translate-x-full'}`}>
//                 {/*content*/}
//                 <div className="border-0 min-h-screen shadow-none relative flex flex-col w-full outline-none focus:outline-none bg-slate-50 dark:bg-slate-800">
//                   {/*header*/}
//                   {/* <div className="flex items-start z-40 justify-between p-5 border-b border-solid border-slate-200 rounded-t"> */}
                  
//                   <ModalHeader caption={lang === 'fr' ? <><i className="fa-solid fa-binoculars mr-2"/>Aperçu Poste</> : <><i className="fa-solid fa-binoculars mr-2"/>Job Preview</>} closeOnClickMethod={() => setJobPreviewOpen(false)}/>
//                   {/* <div className="fixed top-0 bg-inherit flex items-center z-50 px-2 py-1 h-screen">
//                     test
//                   </div> */}
//                   <br/>
//                   <div className="px-8">
                  
//   {talentTarget && 
//                   <TalentPreviewCard
//                             lang={lang || 'en'}
//                             data={talentTarget}
//                             tags={talentTarget.tags}

//                           />
//                           }
//                   </div>
//                   {/* col-span-1 border rounded-lg p-4 prose prose-sm max-w-none h-96 overflow-y-auto bg-white text-slate-700 whitespace-pre-wrap */}

//                   {/* {data[`job_description_${lang || 'en'}`] && <div className={`mx-8 px-6 py-8 my-10 rounded-xl bg-white dark:bg-gray-900 shadow-lg flex-col h-full text-slate-500 dark:text-slate-300 font-inter overflow-auto whitespace-pre-wrap max-w-none `}>

//                   <ReactMarkdownMod args={data[fieldInFocus || `job_description_${lang || 'en'}`]}/>
              
//                     </div>} */}
   
   
//                   {/* <div className="relative p-6 flex-auto text-left">
//                     <div className="my-4 text-slate-500 text-lg leading-relaxed text-gray-900 dark:text-slate-200">
//                     </div>
//                   </div> */}
                      
                    
//                       </div>
                      
//     </div>

//     <ModalSwitchFooter 
//   modal1switch={()=>setTalentPreviewOpen(!talentPreviewOpen)}
//   modal1caption={'Talent'}
//   modal1isOpen={talentPreviewOpen}
//   modal2switch={()=>setJobPreviewOpen(!jobPreviewOpen)}
//   modal2caption={'Job'}
//   modal2isOpen={jobPreviewOpen}
// // missingRequiredFields={'missingFields'} 
// // loading={'loading'} 
// // cancelButtonCaption={lang==='fr' ? 'Annuler' : 'Cancel'} 
// // submitButtonCaption1={lang==='fr' ? <>{talentTarget ? <><i className="fa-solid fa-floppy-disk mr-1"/>Sauvegarder</> : <><i className="fa-solid fa-rocket mr-1"></i>Afficher</>}</> : <>{talentTarget ? <><i className="fa-solid fa-floppy-disk mr-1"/>Save</> : <><i className="fa-solid fa-rocket mr-1"></i>Post</>}</>} 

// submitButtonCaption2={lang === 'fr' ? !talentPreviewOpen ? <><i className="fa-solid fa-eye mr-1"/>Ouvrir Aperçu</> : <><i className="fa-solid fa-eye-slash mr-1"/>Fermer Aperçu</> : talentPreviewOpen ? <><i className="fa-solid fa-eye-slash mr-1"/>Close Preview</> : <><i className="fa-solid fa-eye mr-1"/>Open Preview</>}
// // saveOnClickMethod1={()=>{handleSubmit()}} 
// // saveOnClickMethod2={()=>{setTalentPreviewOpen(!talentPreviewOpen)}}
// // closeOnClickMethod={() => {handleClose()}} 
// // state={{error: state.error, setError: state.setError, success:state.success, setSuccess: state.setSuccess}}
// />

//   </div>
//   {state.submissionModalOpen && < ModalOverlay />}
// </div>
//      )
// }

// export default TalentSubmissionModal